import {
    AppCard,
    DatePicker,
    Popover,
    PopoverContent,
    PopoverTrigger,
    SearchInput,
} from "@jhool-io/fe-components";
import { format } from "date-fns";
import { useSearchParams } from "react-router-dom";
import FilterButton from "../../../../../shared-ui/Buttons/FilterButton/FilterButton";
import { convertDateFilterStringToDate } from "../../../../../utils/helpers";
import MyPendingTasks from "./MyPendingTasks/MyPendingTasks";
import useNewBackground from "../../../../../hooks/useNewBackground";

export default function ProvidersPendingTasks() {
    const [searchParams, setSearchParams] = useSearchParams();

    const fromDateFilter = searchParams.get("task_from_date");
    const toDateFilter = searchParams.get("task_to_date");
    const clientName = searchParams.get("task_client") || "";

    const fromDateFilterToDate = convertDateFilterStringToDate(fromDateFilter);
    const toDateFilterToDate = convertDateFilterStringToDate(toDateFilter);

    const useNewBg = useNewBackground();

    const handleClientNameFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.value === "") searchParams.delete("task_client");
        else searchParams.set("task_client", e.target.value);
        searchParams.set("page", "1");
        setSearchParams(searchParams);
    };

    const handleFromDateFilterChange = (date: Date | null) => {
        if (date === null) searchParams.delete("task_from_date");
        else searchParams.set("task_from_date", format(date, "yyyy-MM-dd"));
        searchParams.set("page", "1");
        setSearchParams(searchParams);
    };

    const handleToDateFilterChange = (date: Date | null) => {
        if (date === null) searchParams.delete("task_to_date");
        else searchParams.set("task_to_date", format(date, "yyyy-MM-dd"));
        searchParams.set("page", "1");
        setSearchParams(searchParams);
    };

    return (
        <AppCard
            mode={useNewBg ? "new" : "old"}
            oldCardClass="border border-strokedark bg-white"
            className="rounded-r12 flex flex-col relative overflow-y-auto h-[600px] lg:h-[430px]"
        >
            <div className="px-16 sticky top-0 left-0">
                <div className="flex justify-between items-center py-20 border-b border-b-strokedark gap-16 flex-wrap">
                    <h3 className="text-base font-medium tracking-[-0.176px] leading-[24px]">
                        Pending Tasks
                    </h3>
                    <div className="flex items-center gap-x-8 gap-y-16 flex-wrap">
                        <SearchInput
                            placeholder="Search by client name"
                            onChange={handleClientNameFilter}
                            defaultValue={clientName}
                            mode={useNewBg ? "new" : "old"}
                        />
                        <Popover>
                            <PopoverTrigger asChild>
                                <FilterButton
                                    text="Date"
                                    mode={useNewBg ? "new" : "old"}
                                />
                            </PopoverTrigger>
                            <PopoverContent
                                align="end"
                                className="p-16 gap-y-12"
                                mode={useNewBg ? "new" : "old"}
                            >
                                <DatePicker
                                    label="From"
                                    placeholderText="MM/DD/YYYY"
                                    selected={fromDateFilterToDate}
                                    onChange={handleFromDateFilterChange}
                                    maxDate={
                                        toDateFilterToDate ||
                                        new Date(Date.now())
                                    }
                                    isClearable
                                />
                                <DatePicker
                                    label="To"
                                    placeholderText="MM/DD/YYYY"
                                    selected={toDateFilterToDate}
                                    onChange={handleToDateFilterChange}
                                    minDate={fromDateFilterToDate}
                                    isClearable
                                />
                            </PopoverContent>
                        </Popover>
                    </div>
                </div>
            </div>
            <div className="flex-1 p-16 overflow-y-auto">
                <MyPendingTasks />
            </div>
        </AppCard>
    );
}
